(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["posthog-analytics"] && !Shopify.designMode) return;
  try {
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="Sn Cn init Hn Un Gn Yi zn Kn qn capture Vn kn calculateEventProperties es register register_once register_for_session unregister unregister_for_session os Bn ss getFeatureFlag getFeatureFlagPayload getFeatureFlagResult getAllFeatureFlags isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync ls identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset us shutdown setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty rs Xn createPersonProfile setInternalOrTestUser ns $n vs opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Jn debug tr At getPageViewId captureTraceFeedback captureTraceMetric Ln".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

  posthog.init('phc_CMhduv2WarYtV9s8TfD9Cv6Dk4cCNdj5tUHMr45tmBgf', {
    api_host: 'https://us.i.posthog.com',
    ui_host: 'https://us.posthog.com',
    defaults: '2026-05-30',

    // Privacy and identity
    opt_out_capturing_by_default: true,
    person_profiles: 'identified_only',
    persistence: 'localStorage+cookie',
    secure_cookie: true,

    // Explicitly controlled collection
    capture_pageview: false,
    capture_pageleave: true,
    capture_performance: true,
    autocapture: false,
    rageclick: false,

    // Keep higher-risk and unused features off
    disable_session_recording: true,
    advanced_disable_flags: true,

    // Remove query strings, hashes, and sensitive account paths.
    before_send: function (event) {
      if (!event) {
        return null;
      }

      var urlFields = [
        '$current_url',
        '$initial_current_url',
        '$referrer',
        '$initial_referrer',
        '$session_entry_url',
        '$external_click_url'
      ];

      function cleanUrl(value) {
        if (typeof value !== 'string' || value === '') {
          return value;
        }

        try {
          var parsed = new URL(value, window.location.origin);
          parsed.search = '';
          parsed.hash = '';

          if (parsed.pathname.indexOf('/account') === 0) {
            parsed.pathname = '/account';
          }

          return parsed.toString();
        } catch (error) {
          return value.split('?')[0].split('#')[0];
        }
      }

      function cleanContainer(container) {
        if (!container || typeof container !== 'object') {
          return;
        }

        urlFields.forEach(function (field) {
          if (typeof container[field] === 'string') {
            container[field] = cleanUrl(container[field]);
          }
        });
      }

      cleanContainer(event.properties);
      cleanContainer(event.$set);
      cleanContainer(event.$set_once);

      return event;
    }
  });
function syncPostHogConsent(){var p=window.Shopify&&Shopify.customerPrivacy;if(!p||!p.analyticsProcessingAllowed()){posthog.opt_out_capturing();return}posthog.opt_in_capturing();if(!window.__quickAxlePostHogPageviewCaptured){window.__quickAxlePostHogPageviewCaptured=true;posthog.capture('$pageview')}}if(window.Shopify&&typeof Shopify.loadFeatures==='function'){Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(e){if(e||!Shopify.customerPrivacy)return;syncPostHogConsent();document.addEventListener('visitorConsentCollected',syncPostHogConsent)})}
  } catch(e) { console.error(e); }
})();

})();
